module Meevo.Plugins.ReportingHierarchy {
    "use strict";

    /**
     * Main Section of Client
     */
    export class MainSection extends BaseSection {
        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        
        createSectionModelInstance(postAdd:(data:any)=>any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }
    }
}